import { render, staticRenderFns } from "./contract-assets.vue?vue&type=template&id=6f8dc14c"
import script from "./contract-assets.vue?vue&type=script&lang=js"
export * from "./contract-assets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports